import { render, staticRenderFns } from "./PermissionsLayout.vue?vue&type=template&id=3c4786ea&"
import script from "./PermissionsLayout.vue?vue&type=script&lang=js&"
export * from "./PermissionsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports